import PeliasRequest from './pelias/request';

const Pelias = function (locationType, language, country, baseUrl) {
  this.locationType = locationType;

  this.geocode = function (term, callback) {
    const request = new PeliasRequest({
      locationType: this.locationType,
      baseUrl: baseUrl,
    });
    request.autoComplete(term, callback);
  }.bind(this);

  this.reverseGeocode = function (latitude, longitude, callback) {
    const request = new PeliasRequest({
      locationType: 'locality,localadmin,borough,macrohood,postalcode,county',
      baseUrl: baseUrl,
    });
    request.reverseGeocode(latitude, longitude, callback);
  };

  this.resultSelected = function (autoCompletedResult, callback) {
    callback(autoCompletedResult);
  };

  this.changeLocationType = function (newLocationType) {
    this.locationType = newLocationType;
  }.bind(this);
};

export default Pelias;
